import React from "react";
import { ButtonSingle } from "../../../../widget/common/form/Button";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { GuestUserFormContextImport } from "../../../../provider/home_guest_user/guest_user_form/GuestUserFormContextProvider";

const GusetUserFormButton = () => {
  const type: number = ResponsiveDeviceType();

  const { handleSubmit } = GuestUserFormContextImport();

  return (
    <ButtonSingle
      width={type === 1 ? undefined : 350}
      handleClick={handleSubmit}
    >
      {AppTranslation.text("submit")}
    </ButtonSingle>
  );
};

export default GusetUserFormButton;
